import React from "react";
import {
  Text,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import { forgotPass } from "../services/forgotPass";
import { GoBackButton } from "./GoBackButton";

export const ForgotPassword = ({ setSignUpp, setEmail: setParentEmail }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) return;
    setLoading(true);
    if (setParentEmail) setParentEmail(email);
    await forgotPass({ email }, setSignUpp, setLoading);
  };

  return (
    <Stack>
      <GoBackButton onClick={() => setSignUpp("signin")} />
      <Text
        color={"primary.500"}
        fontSize="40px"
        fontWeight={"semibold"}
        mb={"-10px"}
      >
        Forgot Password?
      </Text>
      <Text fontSize={"18px"} fontWeight={500}>
        Please enter your email address to get your
        <br /> authentication code
      </Text>
      <FormControl cursor={"pointer"} borderColor="#CFE5E2">
        <FormLabel
          htmlFor="email"
          color={"#4D4A4A"}
          fontSize="18px"
          pt={"17px"}
        >
          Email
        </FormLabel>
        <Input
          id="email"
          type="email"
          bg={"#F9FEFF"}
          mb="15px"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>
      <Button
        bg={"primary.500"}
        size={"md"}
        color="#FFFFFF"
        w="100%"
        fontWeight={400}
        isLoading={loading}
        fontSize={"13px"}
        _hover={{ bg: "primary.600" }}
        onClick={() => handleSubmit()}
        // onClick={() => setSignUpp("newpassword")}
      >
        Continue
      </Button>
    </Stack>
  );
};
